import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
//Components
import LayoutModal from "../../../LayoutModal";
import { useEffect, useState } from "react";
import Loading from "../../../../components/Loading";
import Search from "../../../../components/Search";
//hooks
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
//Interface
import { Inputs, IServiceOrder } from "Interfaces/IServiceOrder";
import { IOrder } from "Interfaces/IOrder";
//Utils
import FormatarData from "utils/FormatData";
import { CurrencyFormat } from "utils/CurrencyFormat";

interface ICreate {
  isOpenModal: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
  updateList: () => void;
}

export default function Update({
  isOpenModal,
  setModalClose,
  selectedUrlId,
  updateList,
}: ICreate) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const [dataSale, setDataSale] = useState<IOrder | null>(null);
  const {
    isLoading: isLoadingAttribute,
    startLoading: startLoadingAttribute,
    stopLoading: stopLoadingAttribute,
  } = useLoading();
  const listHeadLens = [
    "",
    "Esférico",
    "Cilindro",
    "Eixo",
    "DNP",
    "Altura",
    "Adição",
    "DNP V",
    "ALT",
  ];
  const listHeadLensPonte = [
    "Ponte",
    "Hori. Maior",
    "Vert. Maior",
    "Diag. Maior",
  ];
  const listHeadTable = [
    "Tipo",
    "Produto",
    "Qtd.",
    "Preço",
    "Desconto",
    "Subtotal",
  ];
  // Array com os nomes dos campos
  const fieldsOE = [
    "spherical_left",
    "cylindrical_left",
    "axis_left",
    "dnp_left",
    "height_left",
    "addition_left",
    "dnp_v_left",
    "alt_left"
  ] as const;
  const fieldsOD = [
    "spherical_right",
    "cylindrical_right",
    "axis_right",
    "dnp_right",
    "height_right",
    "addition_right",
    "dnp_v_right",
    "alt_right"
  ] as const;
  const fieldsPonte = [
    "bridge",
    "larger_horizontal",
    "larger_vertical",
    "larger_diagonal"
  ] as const;

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(
        `service-order/${selectedUrlId}`
      );

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModal, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoadingAttribute();
    try {
      const payload = {
        ...data,
        sale_id: dataSale ? dataSale?.id : null,
      }

      const response = await apiRequest('service-order', 'POST', payload);
      if (response.status === 201) {
        alert("Ordem de Serviço criada com sucesso!");
        updateList(); // Atualiza os dados na tabela
        onClose(); // Fechar o modal após sucesso
      }
    } catch (error: any) {
      alert(error.message); // Exibe a mensagem de erro lançada pelo serviço
    } finally {
      stopLoadingAttribute();
    }
  };

  const onClose = () => {
    setDataSale(null);
    setModalClose();
    reset();
  };

  const handleSaleSelect = (product: IOrder) => {
    if (product) {
      setDataSale(product);
    }
  }

  const CalculValues = () => {
    if (!dataSale) return { subtotal: 0, totalDiscount: 0 };

    let subtotal = 0;
    let totalDiscount = 0;

    const calculate = (items: any[]) => {
      items.forEach((item) => {
        const quantity = item.pivot.quantity || 0;
        const price = parseFloat(item.pivot.price || '0');
        const discountPercentage = item.pivot.discount || '0';

        const totalItemPrice = quantity * price;
        const discountValue = (totalItemPrice * discountPercentage) / 100;

        subtotal += totalItemPrice;
        totalDiscount += discountValue;
      })
    }

    // Calcula valores para cada categoria
    calculate(dataSale.frames || []);
    calculate(dataSale.services || []);
    calculate(dataSale.lenses || []);

    return { subtotal, totalDiscount };
  }

  const { subtotal, totalDiscount } = CalculValues();

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoadingAttribute}
        title="Registrar Ordem de Serviço"
        subTitle="Cadastre uma nova os em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}

        nameIconMinimize={'Registrar OS'}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            {dataSale &&
              <S.ContentInfor>
                <S.Subtitle>Data da Venda: {FormatarData(dataSale.created_at || '-')}</S.Subtitle>
                <S.Subtitle>Laboratório: {dataSale.lenses.length > 0 ? dataSale.lenses[0].laboratory?.laboratory || 'Não informado' : 'Não informado'}</S.Subtitle>
              </S.ContentInfor>
            }

            <Search
              label="Código de Venda"
              placeholder="Informe o código da venda"
              url="sale?number_ata="
              idSelect={handleSaleSelect}
            />
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Ordem de Serviço
                  <span>*</span>
                </S.Label>
                <S.Input
                  isStyle={true}
                  placeholder="Informe a ordem de serviço"
                  type="text"
                  {...register("number_os", { required: true })}
                  as='input'
                />
                {errors.number_os && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Data de Entrega
                  <span>*</span>
                </S.Label>
                <S.Input
                  isStyle={true}
                  as='input'
                  type="date"
                  {...register("delivery", { required: true })} />
              </S.FormInput>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>Observação</S.Label>
              <S.TextArea
                placeholder="Campo Opcional"
                rows={2}
                {...register("observation")}
              />
            </S.FormInput>

            {/* table */}
            <S.ContainerTable>
              <S.Table>
                <S.Thead>
                  <S.Tr>
                    {listHeadLens.map((header) => {
                      return <th>{header}</th>;
                    })}
                  </S.Tr>
                </S.Thead>

                <S.Tbody>
                  <S.Tr>
                    <S.TdStyle>OD</S.TdStyle>
                    {
                      fieldsOD.map((fieldName, index) => (
                        <S.Td key={index}>
                          <S.Input
                            isStyle={false}
                            as='input'
                            placeholder="0"
                            type="text"
                            {...register(fieldName)}
                          />
                        </S.Td>
                      ))
                    }
                  </S.Tr>

                  <S.Tr>
                    <S.TdStyle>OE</S.TdStyle>
                    {
                      fieldsOE.map((fieldName, index) => (
                        <S.Td key={index}>
                          <S.Input
                            isStyle={false}
                            as='input'
                            placeholder="0"
                            type="text"
                            {...register(fieldName)}
                          />
                        </S.Td>
                      ))
                    }
                  </S.Tr>
                </S.Tbody>
              </S.Table>

              <S.Table>
                <S.Thead>
                  <S.Tr>
                    {listHeadLensPonte.map((header) => {
                      return <th>{header}</th>;
                    })}
                  </S.Tr>
                </S.Thead>

                <S.Tbody>
                  <S.Tr>
                    {
                      fieldsPonte.map((fieldName, index) => (
                        <S.Td key={index}>
                          <S.Input
                            isStyle={false}
                            placeholder="0"
                            type="text"
                            {...register(fieldName)}
                            as='input'
                          />
                        </S.Td>
                      ))
                    }
                  </S.Tr>
                </S.Tbody>
              </S.Table>
            </S.ContainerTable>

            {/* table */}
            {dataSale &&
              <>
                <S.ContainerTable>
                  <S.Table>
                    <S.Thead>
                      <S.Tr>
                        {listHeadTable.map((header) => {
                          return <th>{header}</th>;
                        })}
                      </S.Tr>
                    </S.Thead>

                    <S.Tbody>
                      {
                        dataSale.frames.length > 0 &&
                        dataSale.frames.map((val, index) =>
                          <S.Tr>
                            <S.Td key={index}>
                              Armação
                            </S.Td>
                            <S.Td key={index}>
                              {val.code}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.quantity}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.price || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.discount}%
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.total || '0'))}
                            </S.Td>
                          </S.Tr>
                        )
                      }

                      {
                        dataSale.services.length > 0 &&
                        dataSale.services.map((val, index) =>
                          <S.Tr>
                            <S.Td key={index}>
                              Serviço
                            </S.Td>
                            <S.Td key={index}>
                              {val.name || '-'}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.quantity || '-'}
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.price || '0'))}
                            </S.Td>
                            <S.Td key={index}>
                              {val.pivot.discount || '0'}%
                            </S.Td>
                            <S.Td key={index}>
                              {CurrencyFormat(parseFloat(val.pivot.total || '0'))}
                            </S.Td>
                          </S.Tr>
                        )
                      }

                      {
                        dataSale.lenses.length > 0 &&
                        dataSale.lenses.map((val) =>
                          <S.Tr key={val.id}>
                            <S.Td>
                              Lente
                            </S.Td>
                            <S.Td>
                              {val.name_lens || '-'}
                            </S.Td>
                            <S.Td>
                              {val.pivot.quantity || '0'}
                            </S.Td>
                            <S.Td>
                              {CurrencyFormat(parseFloat(val.pivot.price || '0'))}
                            </S.Td>
                            <S.Td>
                              {val.pivot.discount || '0'}%
                            </S.Td>
                            <S.Td>
                              {CurrencyFormat(parseFloat(val.pivot.total || '0'))}
                            </S.Td>
                          </S.Tr>
                        )
                      }
                    </S.Tbody>
                  </S.Table>
                </S.ContainerTable>

                <S.ContentInfor>
                  <S.Infor>
                    <S.Subtitle>Cliente</S.Subtitle>
                    <S.InforDescription>{dataSale.customer?.full_name || '-'}</S.InforDescription>
                  </S.Infor>

                  <S.Infor>
                    <S.Subtitle>Convênio</S.Subtitle>
                    <S.InforDescription>{dataSale.customer?.agreements?.agreement || 'Não informado'}</S.InforDescription>
                  </S.Infor>

                  <S.Infor>
                    <S.Subtitle>RG/CPF</S.Subtitle>
                    <S.InforDescription>{dataSale.customer?.rg || '-'}/{dataSale.customer?.cpf || '-'}</S.InforDescription>
                  </S.Infor>
                </S.ContentInfor>

                <S.ContentInfor>
                  <S.Subtitle>Total da Compra</S.Subtitle>
                  <S.InforTitle>{CurrencyFormat(parseFloat(dataSale.total_amount || '0'))}</S.InforTitle>
                  <S.Infor>
                    <S.Subtitle>Subtotal</S.Subtitle>
                    <S.InforDescription>{CurrencyFormat(subtotal)}</S.InforDescription>
                  </S.Infor>

                  <S.Infor>
                    <S.Subtitle>Desconto</S.Subtitle>
                    <S.InforDescription>{CurrencyFormat(totalDiscount)}</S.InforDescription>
                  </S.Infor>

                  <S.Infor>
                    <S.Subtitle>Forma de Pagamento</S.Subtitle>
                    <S.InforDescription>{dataSale.payment_method.payment_method}</S.InforDescription>
                  </S.Infor>
                </S.ContentInfor>
              </>
            }
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
